module.exports = __webpack_public_path__ + "static/media/ElephantCompanyImage.2e15f64c.svg";